class TypeWriter {
  constructor(element, words, waitTime = 2000) {
    this.element = element;
    this.words = words;
    this.txt = '';
    this.wordIndex = 0;
    this.waitTime = parseInt(waitTime, 8);
    this.isDeleting = false;
    this.isWaiting = false;
    this.typeSpeed = 100;
    // Slower delete speed on mobile
    this.deleteSpeed = window.innerWidth <= 749 ? 55 : 50;
    
    // Clear any existing text in the element
    this.element.textContent = '';
    
    // Create text span
    this.textSpan = document.createElement('span');
    this.element.appendChild(this.textSpan);
    
    // Start the animation loop
    this.lastTime = performance.now();
    this.type();
  }

  updateCursorState() {
    requestAnimationFrame(() => {
      this.element.classList.remove('typing', 'waiting');
      if (this.isWaiting) {
        this.element.classList.add('waiting');
      } else if (this.isDeleting || this.txt.length < this.words[this.wordIndex % this.words.length].length) {
        this.element.classList.add('typing');
      }
    });
  }

  type() {
    // Current word index
    const current = this.wordIndex % this.words.length;
    // Get full text of current word
    const fullTxt = this.words[current];

    // Check if deleting
    if(this.isDeleting) {
      // Remove char
      this.txt = fullTxt.substring(0, this.txt.length - 1);
    } else {
      // Add char
      this.txt = fullTxt.substring(0, this.txt.length + 1);
    }

    // Update text content using requestAnimationFrame for smooth updates
    requestAnimationFrame(() => {
      this.textSpan.textContent = this.txt;
    });

    // Calculate type speed
    let typeSpeed = this.isDeleting ? this.deleteSpeed : this.typeSpeed;

    // If word is complete
    if(!this.isDeleting && this.txt === fullTxt) {
      // Make pause at end
      typeSpeed = this.waitTime;
      // Set delete to true
      this.isDeleting = true;
      this.isWaiting = true;
    } else if(this.isDeleting && this.txt === '') {
      this.isDeleting = false;
      this.isWaiting = false;
      // Move to next word
      this.wordIndex++;
      // Pause before start typing
      typeSpeed = 500;
    } else {
      this.isWaiting = false;
    }

    // Update cursor state
    this.updateCursorState();

    // Schedule next update
    setTimeout(() => this.type(), typeSpeed);
  }
}

// Init On DOM Load
document.addEventListener('DOMContentLoaded', function() {
  const typewriterElement = document.querySelector('.typewriter-text');
  if (typewriterElement) {
    // Reduced motion: the markup's static first word stands, nothing types
    if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    new TypeWriter(typewriterElement, ['happiness.', 'confidence.', 'enthusiasm.'], 2000);
  }
});
